module.exports = __webpack_public_path__ + "img/frame12_stamp.cd15637c.png";